import React from 'react';
import { Box, Typography } from '@mui/material';

export default function DecommissionedPage() {
    return (
        <Box sx={{
            display: "flex", flexDirection: "row",
            justifyContent: "center", alignItems: "center",
            width: 1, height: 1
        }}>
            <Typography>Dear Online Recognition Portal Users,<br />
                As our recognition program has shifted back to a physical format with cards and boards, we have <br />
                decided to close the online recognition portal from the end of September 2024.
            </Typography>
        </Box>
    );
}